export interface Country {
    readonly name: string,
    readonly value: string
}

export const countryResource = [
    {
        name: 'Select Country', value: ''
    },
    {
        name: 'Germany', value: 'DE'
    },
    {
        name: 'Poland', value: 'PL'
    },
    {
        name: 'USA', value: 'US'
    },
    {
        name: 'India', value: 'IND'
    },
    {
        name: 'Austria', value: 'AT'
    },
    {
        name: 'World', value: 'WW'
    },
    {
        name: 'Cross country', value: 'XC'
    }
];
